import React, { lazy, Suspense } from "react"
import { Route, Switch, Redirect } from "react-router-dom"
// Landing
// import DefaultLayout from "./landing/DefaultLayout"
// import Main from "./landing/Main"
import NotFound from "./common/NotFound"
import Loader from "./common/Loader"
//Auth
import { ROUTES } from "./common/utils/"
import LogOut from "./sign/LogOut"
import Auth from "./common/Auth"
import Admin from "./Admin"
import SubscriptionPayment from "./account/SubscriptionPayment"
import SubscriptionReturn from "./account/SubscriptionReturn"
import SubscriptionCancel from "./account/SubscriptionCancel"

//Dasboard Components
import CreateAccount from "./account/CreateAccount"
import TrialExpiryPage from "./account/TrialExpiryPage"
import "./App.css"
import DirectCheckout from "./DirectCheckout/DirectCheckout"
import RedirectCheckoutCoinsph from "./DirectCheckout/RedirectCheckoutCoinsph"
import ProductDetails from "./DirectCheckout/ViewProductDetails/ProductDetails"
import UserInformation from "./account/UserInformation/UserInformation"
//lazy load components
const SignUp = lazy(() => import("./sign/SignUp"))
const Login = lazy(() => import("./sign/Login"))
const ForgotPassword = lazy(() => import("./sign/ForgotPassword"))
const EmailVerificationWall = lazy(() =>
  import("./sign/email-verification/EmailVerificationWall")
)
// const ThankYou = lazy(() => import("./landing/ThankYou"))
// const About = lazy(() => import("./landing/About"))
// const Contact = lazy(() => import("./landing/Contact"))
// const Terms = lazy(() => import("./landing/Terms"))
// const PrivacyPolicy = lazy(() => import("./landing/PrivacyPolicy"))
const CustomerResetPassword = lazy(() =>
  import("./customer-account/CustomerResetPassword")
)
const EmailVerificationSuccess = lazy(() =>
  import("./DirectCheckout/CustomerInfo/EmailVerificationSuccess/EmailVerificationSuccess")
)
const CustomerLogin = lazy(() => import("./customer-account/CustomerLogin"))
const UnsubscribeQuestion = lazy(() => import("./account/Unsubscribe/Question"))
const Confirmation = lazy(() => import("./account/Unsubscribe/Confirmation"))
const Reactivate = lazy(() => import("./account/Unsubscribe/Reactivate"))
const FreeTrialExpired = lazy(() => import("./sign/Login/FreeTrialExpired"))

class App extends React.Component {
  render() {
    return (
      <div className="App">
        <Suspense maxDuration={2000} fallback={<Loader />}>
          <Switch>
            <Route
              exact
              path={ROUTES.HOME}
              render={() => <Redirect to={ROUTES.ADMIN} />}
            />
            {/* <DefaultLayout exact path={ROUTES.HOME} component={Main} />
            <DefaultLayout
              exact
              path={ROUTES.ABOUT}
              component={props => <About {...props} />}
            />
            <DefaultLayout
              exact
              path={ROUTES.CONTACT}
              component={props => <Contact {...props} />}
            />
            <DefaultLayout
              exact
              path={ROUTES.TERMS}
              component={props => <Terms {...props} />}
            />
            <DefaultLayout
              exact
              path={ROUTES.PRIVACYPOLICY}
              component={props => <PrivacyPolicy {...props} />}
            /> */}
            <Route
              path={`${ROUTES.LOGIN}/`}
              component={props => <Login {...props} />}
            />
            <Route
              exact
              path={`${ROUTES.UNSUBSCRIBE}/`}
              component={props => <UnsubscribeQuestion {...props} />}
            />
            <Route
              exact
              path={`${ROUTES.UNSUBSCRIBECONFIRMATION}/`}
              component={props => <Confirmation {...props} />}
            />
            <Route
              exact
              path={`${ROUTES.REACTIVATE}/`}
              component={props => <Reactivate {...props} />}
            />
            <Route
              path={`${ROUTES.SIGNUP}/:code?`}
              component={props => <SignUp {...props} />}
            />
            <Route
              path={ROUTES.FORGOTPASSWORD}
              component={props => <ForgotPassword {...props} />}
            />
            <Route
              path={ROUTES.VERIFY_EMAIL}
              component={props => <EmailVerificationWall {...props} />}
            />
            {/* <Route
              path={ROUTES.THANKYOU}
              component={props => <ThankYou {...props} />}
            /> */}
            <Route
              exact
              path={ROUTES.DIRECT_CHECKOUT}
              component={props => <DirectCheckout {...props} />}
            />
            <Route
              exact
              path={ROUTES.REDIRECT_CHECKOUT_COINSPH}
              component={props => <RedirectCheckoutCoinsph {...props} />}
            />
            <Route
              exact
              path={ROUTES.CHECKOUT_PRODUCT_DETAILS}
              component={props => <ProductDetails {...props} />}
            />
            <Route
              path={ROUTES.CUSTOMER_RESETPASSWORD}
              component={props => <CustomerResetPassword {...props} />}
            />
            <Route
              path={ROUTES.CUSTOMER_VERIFYEMAIL}
              component={props => <EmailVerificationSuccess {...props} />}
            />
            <Route
              path={ROUTES.CUSTOMER_LOGIN}
              component={props => <CustomerLogin {...props} />}
            />
            {/* Admin Paths */}
            <Auth path={ROUTES.TRIAL_EXPIRY} component={TrialExpiryPage} />
            <Route
              exact
              path={ROUTES.FREE_TRIAL_LINK}
              component={props => <FreeTrialExpired {...props} />}
            />
            <Auth
              path={ROUTES.SUBSCRIPTION_PAYMENT}
              component={SubscriptionPayment}
              exact
            />
            <Auth
              path={ROUTES.SUBSCRIPTION_RETURN}
              component={SubscriptionReturn}
              exact
            />
            <Auth
              path={ROUTES.SUBSCRIPTION_CANCEL}
              component={SubscriptionCancel}
              exact
            />
            <Route
              path={ROUTES.CUSTOMER_RESETPASSWORD}
              component={props => <CustomerResetPassword {...props} />}
            />
            {/* Admin Paths */}
            <Auth path={`${ROUTES.USER_INFO}`} component={UserInformation} />
            <Auth
              path={`${ROUTES.CREATE_ACCOUNT}/`}
              component={CreateAccount}
            />
            <Auth
              path={`${ROUTES.ADMIN}/`}
              component={Admin}
              reactivating={true}
            />
            <Auth path={ROUTES.LOGOUT} component={LogOut} />
            <Route component={NotFound} />
          </Switch>
        </Suspense>
      </div>
    )
  }
}

export default App
